module.exports = __webpack_public_path__ + "static/media/strategic.5cb7ee9b.png";